<template>
    <div class="checkbox" :class="{'is-checked' : isChecked }" v-if="!isHidden">
        <label :for="`${_uid}-form-${form.id}`">
            <div class="icon">
                <i v-if="isChecked" class="fa fa-check-circle text-success"></i>
                <i v-else class="fa fa-times-circle text-danger"></i>
            </div>
            <div class="input">
                <input type="checkbox" :id="`${_uid}-form-${form.id}`" v-model="selected" :value="form.id" @change="updateItems">
            </div>
            <div class="info">
                <div class="name">
                    <span v-text="form.name"></span>
                    <a class="hide" href="#" @click="hideForm()">(Hide)</a>
                </div>
            </div>
        </label>
    </div>
</template>
<script>
    export default {

        props: {
            value: {
                type: Array,
                required: true,
            },
            form: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                isHidden: false,
                selected: this.value
            }
        },

        created() {
            var hiddenForms = Storage.get(`user-${App.config.userId}-hiden-forms`);
            if (!hiddenForms) hiddenForms = [];
            this.isHidden = !!_.find(hiddenForms, id => {
                return this.form.id == id;
            });
            App.bus.$on('show-hiden-forms', () => {
                this.isHidden = false;
            })
        },

        methods: {

            updateItems() {
                this.$emit('input', this.selected)
            },

            hideForm() {
                this.isHidden = true;
                App.bus.$emit('hide-form', this.form)
            }
        },

        watch: {
            value(val) {
                this.selected = val;
            }
        },

        computed: {

            isChecked() {
                return !!_.find(this.selected, id => {
                    return id == this.form.id
                })
            },
        }
    }
</script>
